import { createRef } from "react";
import { PropTypes } from "prop-types";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export function DownloadLink({ url, filename, children }) {
	const link = createRef();
	const {axiosPrivate} = useAxiosPrivate();

	const handleAction = async () => {
		let anchor = document.createElement("a");
		document.body.appendChild(anchor);

		axiosPrivate.get(url, {responseType: "blob"})
			.then((response) => {
				const link = url.split("attachments/");
				return new File([response.data], link[1]);
			})
			.then((blobby) => {
				let objectUrl = window.URL.createObjectURL(blobby);

				anchor.href = objectUrl;
				anchor.download = filename;
				anchor.click();

				window.URL.revokeObjectURL(objectUrl);
			});
	};

	return (
		<>
			<a role="button" ref={link} onClick={handleAction}>
				{children}
			</a>
		</>
	);
}

DownloadLink.propTypes = {
	url: PropTypes.string,
	filename: PropTypes.string,
	children: PropTypes.any,
	// axiosPrivate: PropTypes.any,
};
